import { createSlice } from "@reduxjs/toolkit";
import { getUserWorkspaces, createWorkspace, switchWorkspace } from "../thunks/workspaceThunk";
import { IWorkspaceState } from "../types/workspace";
import { IWorkspace } from "../../../shared/services/interface/responses/IWorkspaceResponses";

const initialState: IWorkspaceState = {
  workspaces: [],
  currentWorkspace: null,
  loading: false,
  error: null,
};

export const workspaceSlice = createSlice({
  name: "workspace",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setCurrentWorkspace: (state, action) => {
      state.currentWorkspace = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // getUserWorkspaces
      .addCase(getUserWorkspaces.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUserWorkspaces.fulfilled, (state, action) => {
        state.loading = false;
        state.workspaces = action.payload.data.workspaces;
        // Mevcut workspace'i bul
        const currentWorkspace = action.payload.data.workspaces.find((ws: IWorkspace) => ws.isCurrentWorkspace);
        if (currentWorkspace) {
          state.currentWorkspace = currentWorkspace;
        }
      })
      .addCase(getUserWorkspaces.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      // createWorkspace
      .addCase(createWorkspace.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createWorkspace.fulfilled, (state) => {
        state.loading = false;
        // Yeni workspace oluşturulduktan sonra listeyi yenile
        // Bu durumda getUserWorkspaces çağrılabilir
        // Not: Component'te createWorkspace başarılı olduktan sonra fetchWorkspaces çağrılmalı
      })
      .addCase(createWorkspace.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      // switchWorkspace
      .addCase(switchWorkspace.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(switchWorkspace.fulfilled, (state) => {
        state.loading = false;
        // Workspace değiştirildikten sonra listeyi yenile
        // Bu durumda getUserWorkspaces çağrılabilir
        // Not: Component'te switchWorkspace başarılı olduktan sonra fetchWorkspaces çağrılmalı
      })
      .addCase(switchWorkspace.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearError, setLoading, setCurrentWorkspace } = workspaceSlice.actions;
export default workspaceSlice.reducer; 